<app-paginator
	#p
	[mfTable]="mfTable"
>
	@if (p.dataLength > minRowsOnPage) {
		<select
			(change)="p.setRowsOnPage($event)"
			class="defaultInput"
		>
			@for (rows of rowsOnPageSet; track rows) {
				<option
					[selected]="p.rowsOnPage === rows"
					[value]="rows"
				>
					{{ "paginator.showNResults" | translate: { rows: rows } }}
				</option>
			}
		</select>
	}
</app-paginator>
